<template>
  <card
    @onRemoveItem="handleRemove"
    :item="item"
    model="character"
    :image="imagePath"
    :url="url"
    :user="user"
  >
    <CardItemList>
      <CardDetail label="Birth Year" :val="item.birth_year" />
      <CardDetail label="Number Ponies" :val="item.num_ponies" />
    </CardItemList>
    <h3 class="card-details-title">Ponies:</h3>
    <CardItemList
      v-if="item.ponies && item.ponies.length"
      :items="item.ponies"
      model="pony"
    />
  </card>
</template>

<script>
import { capitalize, getImagePath } from "../../utils/helpers";
import Card from "../Card/Card";
import CardDetail from "../CardDetail/CardDetail";
import CardItemList from "../CardItemList/CardItemList";

export default {
  name: "CharacterCard",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Card,
    CardDetail,
    CardItemList,
  },
  computed: {
    imagePath() {
      return getImagePath(this.item?.image);
    },
    url() {
      return `/character/${this.item.slug}`;
    },
  },
  methods: {
    capitalize,
    handleRemove() {
      this.$emit("onRemove", { slug: this.item.slug });
    },
  },
};
</script>

<style lang="scss" scoped>
ul.character-details {
  border-bottom: 1px solid #ccc;
  padding-left: 5px;
}
</style>
